// @generated by protoc-gen-connect-query v0.2.0 with parameter "target=ts"
// @generated from file recording/v1/recording_api.proto (package recording.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { createQueryService } from "@bufbuild/connect-query";
import { MethodKind } from "@bufbuild/protobuf";
import { AnnotateRecordingRequest, AnnotateRecordingResponse, CaptureCameraFrameRequest, CaptureCameraFrameResponse, CreateCameraVerificationFrameRequest, CreateCameraVerificationFrameResponse, CreateCourtVerificationFrameForPracticeRequest, CreateCourtVerificationFrameForPracticeResponse, CreateCourtVerificationFrameRequest, CreateCourtVerificationFrameResponse, CreatePracticeRequest, CreatePracticeResponse, CreateRecordingRequest, CreateRecordingResponse, DeleteAnnotationRequest, DeleteAnnotationResponse, DeleteExportRequest, DeleteExportResponse, DeletePracticeRequest, DeletePracticeResponse, DeleteRecordingRequest, DeleteRecordingResponse, ExportRecordingRequest, ExportRecordingResponse, ExportRecordingZipRequest, ExportRecordingZipResponse, GenerateRecordingHitDatasetRequest, GenerateRecordingHitDatasetResponse, GetPracticeRequest, GetPracticeResponse, GetRecordingRequest, GetRecordingResponse, ListPracticesRequest, ListPracticesResponse, ListRecordingFramesRequest, ListRecordingFramesResponse, ListRecordingsRequest, ListRecordingsResponse, ProcessPracticeRequest, ProcessPracticeResponse, ProcessRecordingRequest, ProcessRecordingResponse, RegeneratePracticeThumbnailRequest, RegeneratePracticeThumbnailResponse, RegenerateRecordingThumbnailRequest, RegenerateRecordingThumbnailResponse, ReProcessPracticeRequest, ReProcessPracticeResponse, ReProcessRecordingRequest, ReProcessRecordingResponse, SendLiveRecordingCommandsRequest, SendLiveRecordingCommandsResponse, StartLiveRecordingRequest, StartLiveRecordingResponse, UpdateAnnotationNameRequest, UpdateAnnotationNameResponse, UpdateExportNameRequest, UpdateExportNameResponse, UpdatePracticeEmptyCourtRequest, UpdatePracticeEmptyCourtResponse, UpdateRecordingEmptyCourtRequest, UpdateRecordingEmptyCourtResponse, UpdateRecordingMatchTypeRequest, UpdateRecordingMatchTypeResponse, UpdateRecordingNameRequest, UpdateRecordingNameResponse, UpdateRecordingNotesRequest, UpdateRecordingNotesResponse, UpdateRecordingPasswordRequest, UpdateRecordingPasswordResponse, UpdateRecordingReportRequest, UpdateRecordingReportResponse, UpdateRecordingScoreRequest, UpdateRecordingScoreResponse, UpdateRecordingSettingsRequest, UpdateRecordingSettingsResponse, UpdateRecordingTagRequest, UpdateRecordingTagResponse, UpdateRecordingTournamentRequest, UpdateRecordingTournamentResponse, UpdateRecordingTournamentStageKeyRequest, UpdateRecordingTournamentStageKeyResponse } from "./recording_api_pb.js";

export const typeName = "recording.v1.RecordingAPI";

/**
 * @generated from rpc recording.v1.RecordingAPI.StartLiveRecording
 */
export const startLiveRecording = createQueryService({
  service: {
    methods: {
      startLiveRecording: {
        name: "StartLiveRecording",
        kind: MethodKind.Unary,
        I: StartLiveRecordingRequest,
        O: StartLiveRecordingResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).startLiveRecording;

/**
 * @generated from rpc recording.v1.RecordingAPI.CaptureCameraFrame
 */
export const captureCameraFrame = createQueryService({
  service: {
    methods: {
      captureCameraFrame: {
        name: "CaptureCameraFrame",
        kind: MethodKind.Unary,
        I: CaptureCameraFrameRequest,
        O: CaptureCameraFrameResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).captureCameraFrame;

/**
 * @generated from rpc recording.v1.RecordingAPI.CreateCameraVerificationFrame
 */
export const createCameraVerificationFrame = createQueryService({
  service: {
    methods: {
      createCameraVerificationFrame: {
        name: "CreateCameraVerificationFrame",
        kind: MethodKind.Unary,
        I: CreateCameraVerificationFrameRequest,
        O: CreateCameraVerificationFrameResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).createCameraVerificationFrame;

/**
 * @generated from rpc recording.v1.RecordingAPI.SendLiveRecordingCommands
 */
export const sendLiveRecordingCommands = createQueryService({
  service: {
    methods: {
      sendLiveRecordingCommands: {
        name: "SendLiveRecordingCommands",
        kind: MethodKind.Unary,
        I: SendLiveRecordingCommandsRequest,
        O: SendLiveRecordingCommandsResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).sendLiveRecordingCommands;

/**
 * @generated from rpc recording.v1.RecordingAPI.CreateRecording
 */
export const createRecording = createQueryService({
  service: {
    methods: {
      createRecording: {
        name: "CreateRecording",
        kind: MethodKind.Unary,
        I: CreateRecordingRequest,
        O: CreateRecordingResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).createRecording;

/**
 * @generated from rpc recording.v1.RecordingAPI.RegenerateRecordingThumbnail
 */
export const regenerateRecordingThumbnail = createQueryService({
  service: {
    methods: {
      regenerateRecordingThumbnail: {
        name: "RegenerateRecordingThumbnail",
        kind: MethodKind.Unary,
        I: RegenerateRecordingThumbnailRequest,
        O: RegenerateRecordingThumbnailResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).regenerateRecordingThumbnail;

/**
 * @generated from rpc recording.v1.RecordingAPI.ProcessRecording
 */
export const processRecording = createQueryService({
  service: {
    methods: {
      processRecording: {
        name: "ProcessRecording",
        kind: MethodKind.Unary,
        I: ProcessRecordingRequest,
        O: ProcessRecordingResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).processRecording;

/**
 * @generated from rpc recording.v1.RecordingAPI.ReProcessRecording
 */
export const reProcessRecording = createQueryService({
  service: {
    methods: {
      reProcessRecording: {
        name: "ReProcessRecording",
        kind: MethodKind.Unary,
        I: ReProcessRecordingRequest,
        O: ReProcessRecordingResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).reProcessRecording;

/**
 * @generated from rpc recording.v1.RecordingAPI.CreateCourtVerificationFrame
 */
export const createCourtVerificationFrame = createQueryService({
  service: {
    methods: {
      createCourtVerificationFrame: {
        name: "CreateCourtVerificationFrame",
        kind: MethodKind.Unary,
        I: CreateCourtVerificationFrameRequest,
        O: CreateCourtVerificationFrameResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).createCourtVerificationFrame;

/**
 * @generated from rpc recording.v1.RecordingAPI.ListRecordings
 */
export const listRecordings = createQueryService({
  service: {
    methods: {
      listRecordings: {
        name: "ListRecordings",
        kind: MethodKind.Unary,
        I: ListRecordingsRequest,
        O: ListRecordingsResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).listRecordings;

/**
 * @generated from rpc recording.v1.RecordingAPI.GetRecording
 */
export const getRecording = createQueryService({
  service: {
    methods: {
      getRecording: {
        name: "GetRecording",
        kind: MethodKind.Unary,
        I: GetRecordingRequest,
        O: GetRecordingResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).getRecording;

/**
 * @generated from rpc recording.v1.RecordingAPI.DeleteRecording
 */
export const deleteRecording = createQueryService({
  service: {
    methods: {
      deleteRecording: {
        name: "DeleteRecording",
        kind: MethodKind.Unary,
        I: DeleteRecordingRequest,
        O: DeleteRecordingResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).deleteRecording;

/**
 * @generated from rpc recording.v1.RecordingAPI.ListRecordingFrames
 */
export const listRecordingFrames = createQueryService({
  service: {
    methods: {
      listRecordingFrames: {
        name: "ListRecordingFrames",
        kind: MethodKind.Unary,
        I: ListRecordingFramesRequest,
        O: ListRecordingFramesResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).listRecordingFrames;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingNotes
 */
export const updateRecordingNotes = createQueryService({
  service: {
    methods: {
      updateRecordingNotes: {
        name: "UpdateRecordingNotes",
        kind: MethodKind.Unary,
        I: UpdateRecordingNotesRequest,
        O: UpdateRecordingNotesResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingNotes;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingName
 */
export const updateRecordingName = createQueryService({
  service: {
    methods: {
      updateRecordingName: {
        name: "UpdateRecordingName",
        kind: MethodKind.Unary,
        I: UpdateRecordingNameRequest,
        O: UpdateRecordingNameResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingName;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingMatchType
 */
export const updateRecordingMatchType = createQueryService({
  service: {
    methods: {
      updateRecordingMatchType: {
        name: "UpdateRecordingMatchType",
        kind: MethodKind.Unary,
        I: UpdateRecordingMatchTypeRequest,
        O: UpdateRecordingMatchTypeResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingMatchType;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingEmptyCourt
 */
export const updateRecordingEmptyCourt = createQueryService({
  service: {
    methods: {
      updateRecordingEmptyCourt: {
        name: "UpdateRecordingEmptyCourt",
        kind: MethodKind.Unary,
        I: UpdateRecordingEmptyCourtRequest,
        O: UpdateRecordingEmptyCourtResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingEmptyCourt;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingReport
 */
export const updateRecordingReport = createQueryService({
  service: {
    methods: {
      updateRecordingReport: {
        name: "UpdateRecordingReport",
        kind: MethodKind.Unary,
        I: UpdateRecordingReportRequest,
        O: UpdateRecordingReportResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingReport;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingPassword
 */
export const updateRecordingPassword = createQueryService({
  service: {
    methods: {
      updateRecordingPassword: {
        name: "UpdateRecordingPassword",
        kind: MethodKind.Unary,
        I: UpdateRecordingPasswordRequest,
        O: UpdateRecordingPasswordResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingPassword;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingScore
 */
export const updateRecordingScore = createQueryService({
  service: {
    methods: {
      updateRecordingScore: {
        name: "UpdateRecordingScore",
        kind: MethodKind.Unary,
        I: UpdateRecordingScoreRequest,
        O: UpdateRecordingScoreResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingScore;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingTag
 */
export const updateRecordingTag = createQueryService({
  service: {
    methods: {
      updateRecordingTag: {
        name: "UpdateRecordingTag",
        kind: MethodKind.Unary,
        I: UpdateRecordingTagRequest,
        O: UpdateRecordingTagResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingTag;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingSettings
 */
export const updateRecordingSettings = createQueryService({
  service: {
    methods: {
      updateRecordingSettings: {
        name: "UpdateRecordingSettings",
        kind: MethodKind.Unary,
        I: UpdateRecordingSettingsRequest,
        O: UpdateRecordingSettingsResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingSettings;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingTournament
 */
export const updateRecordingTournament = createQueryService({
  service: {
    methods: {
      updateRecordingTournament: {
        name: "UpdateRecordingTournament",
        kind: MethodKind.Unary,
        I: UpdateRecordingTournamentRequest,
        O: UpdateRecordingTournamentResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingTournament;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateRecordingTournamentStageKey
 */
export const updateRecordingTournamentStageKey = createQueryService({
  service: {
    methods: {
      updateRecordingTournamentStageKey: {
        name: "UpdateRecordingTournamentStageKey",
        kind: MethodKind.Unary,
        I: UpdateRecordingTournamentStageKeyRequest,
        O: UpdateRecordingTournamentStageKeyResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateRecordingTournamentStageKey;

/**
 * @generated from rpc recording.v1.RecordingAPI.GenerateRecordingHitDataset
 */
export const generateRecordingHitDataset = createQueryService({
  service: {
    methods: {
      generateRecordingHitDataset: {
        name: "GenerateRecordingHitDataset",
        kind: MethodKind.Unary,
        I: GenerateRecordingHitDatasetRequest,
        O: GenerateRecordingHitDatasetResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).generateRecordingHitDataset;

/**
 * @generated from rpc recording.v1.RecordingAPI.ExportRecording
 */
export const exportRecording = createQueryService({
  service: {
    methods: {
      exportRecording: {
        name: "ExportRecording",
        kind: MethodKind.Unary,
        I: ExportRecordingRequest,
        O: ExportRecordingResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).exportRecording;

/**
 * @generated from rpc recording.v1.RecordingAPI.DeleteExport
 */
export const deleteExport = createQueryService({
  service: {
    methods: {
      deleteExport: {
        name: "DeleteExport",
        kind: MethodKind.Unary,
        I: DeleteExportRequest,
        O: DeleteExportResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).deleteExport;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateExportName
 */
export const updateExportName = createQueryService({
  service: {
    methods: {
      updateExportName: {
        name: "UpdateExportName",
        kind: MethodKind.Unary,
        I: UpdateExportNameRequest,
        O: UpdateExportNameResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateExportName;

/**
 * @generated from rpc recording.v1.RecordingAPI.AnnotateRecording
 */
export const annotateRecording = createQueryService({
  service: {
    methods: {
      annotateRecording: {
        name: "AnnotateRecording",
        kind: MethodKind.Unary,
        I: AnnotateRecordingRequest,
        O: AnnotateRecordingResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).annotateRecording;

/**
 * @generated from rpc recording.v1.RecordingAPI.DeleteAnnotation
 */
export const deleteAnnotation = createQueryService({
  service: {
    methods: {
      deleteAnnotation: {
        name: "DeleteAnnotation",
        kind: MethodKind.Unary,
        I: DeleteAnnotationRequest,
        O: DeleteAnnotationResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).deleteAnnotation;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdateAnnotationName
 */
export const updateAnnotationName = createQueryService({
  service: {
    methods: {
      updateAnnotationName: {
        name: "UpdateAnnotationName",
        kind: MethodKind.Unary,
        I: UpdateAnnotationNameRequest,
        O: UpdateAnnotationNameResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updateAnnotationName;

/**
 * @generated from rpc recording.v1.RecordingAPI.ExportRecordingZip
 */
export const exportRecordingZip = createQueryService({
  service: {
    methods: {
      exportRecordingZip: {
        name: "ExportRecordingZip",
        kind: MethodKind.Unary,
        I: ExportRecordingZipRequest,
        O: ExportRecordingZipResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).exportRecordingZip;

/**
 * @generated from rpc recording.v1.RecordingAPI.CreatePractice
 */
export const createPractice = createQueryService({
  service: {
    methods: {
      createPractice: {
        name: "CreatePractice",
        kind: MethodKind.Unary,
        I: CreatePracticeRequest,
        O: CreatePracticeResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).createPractice;

/**
 * @generated from rpc recording.v1.RecordingAPI.RegeneratePracticeThumbnail
 */
export const regeneratePracticeThumbnail = createQueryService({
  service: {
    methods: {
      regeneratePracticeThumbnail: {
        name: "RegeneratePracticeThumbnail",
        kind: MethodKind.Unary,
        I: RegeneratePracticeThumbnailRequest,
        O: RegeneratePracticeThumbnailResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).regeneratePracticeThumbnail;

/**
 * @generated from rpc recording.v1.RecordingAPI.ProcessPractice
 */
export const processPractice = createQueryService({
  service: {
    methods: {
      processPractice: {
        name: "ProcessPractice",
        kind: MethodKind.Unary,
        I: ProcessPracticeRequest,
        O: ProcessPracticeResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).processPractice;

/**
 * @generated from rpc recording.v1.RecordingAPI.ReProcessPractice
 */
export const reProcessPractice = createQueryService({
  service: {
    methods: {
      reProcessPractice: {
        name: "ReProcessPractice",
        kind: MethodKind.Unary,
        I: ReProcessPracticeRequest,
        O: ReProcessPracticeResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).reProcessPractice;

/**
 * @generated from rpc recording.v1.RecordingAPI.CreateCourtVerificationFrameForPractice
 */
export const createCourtVerificationFrameForPractice = createQueryService({
  service: {
    methods: {
      createCourtVerificationFrameForPractice: {
        name: "CreateCourtVerificationFrameForPractice",
        kind: MethodKind.Unary,
        I: CreateCourtVerificationFrameForPracticeRequest,
        O: CreateCourtVerificationFrameForPracticeResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).createCourtVerificationFrameForPractice;

/**
 * @generated from rpc recording.v1.RecordingAPI.ListPractices
 */
export const listPractices = createQueryService({
  service: {
    methods: {
      listPractices: {
        name: "ListPractices",
        kind: MethodKind.Unary,
        I: ListPracticesRequest,
        O: ListPracticesResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).listPractices;

/**
 * @generated from rpc recording.v1.RecordingAPI.GetPractice
 */
export const getPractice = createQueryService({
  service: {
    methods: {
      getPractice: {
        name: "GetPractice",
        kind: MethodKind.Unary,
        I: GetPracticeRequest,
        O: GetPracticeResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).getPractice;

/**
 * @generated from rpc recording.v1.RecordingAPI.DeletePractice
 */
export const deletePractice = createQueryService({
  service: {
    methods: {
      deletePractice: {
        name: "DeletePractice",
        kind: MethodKind.Unary,
        I: DeletePracticeRequest,
        O: DeletePracticeResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).deletePractice;

/**
 * @generated from rpc recording.v1.RecordingAPI.UpdatePracticeEmptyCourt
 */
export const updatePracticeEmptyCourt = createQueryService({
  service: {
    methods: {
      updatePracticeEmptyCourt: {
        name: "UpdatePracticeEmptyCourt",
        kind: MethodKind.Unary,
        I: UpdatePracticeEmptyCourtRequest,
        O: UpdatePracticeEmptyCourtResponse,
      },
    },
    typeName: "recording.v1.RecordingAPI",
  },
}).updatePracticeEmptyCourt;
